import { toast } from "@/hooks/use-toast";

/**
 * Mostra una notifica di operazione completata con successo
 * @param message Messaggio da visualizzare (default "Salvataggio completato")
 */
export function showSuccessNotification(message: string = "Salvataggio completato") {
  toast({
    title: "Operazione completata",
    description: message,
    variant: "default",
    className: "bg-green-600 text-white border-green-700", // Sfondo verde
    duration: 3000, // 3 secondi
  });
}

/**
 * Mostra una notifica di errore 
 * @param message Messaggio di errore da visualizzare (default "Errore durante il salvataggio")
 */
export function showErrorNotification(message: string = "Errore durante il salvataggio") {
  toast({
    title: "Errore",
    description: message,
    variant: "destructive", // Il tema destructive è già rosso
    className: "bg-red-600 text-white border-red-700", // Personalizzato ulteriormente
    duration: 3000, // 3 secondi
  });
}

